var L = require('leaflet')
var toGeoJSON = require('@mapbox/togeojson');

require('leaflet.markercluster')
require('leaflet-gesture-handling')
require('leaflet.featuregroup.subgroup');

let map = null
//const mapCenter = [-21.1918, 55.3739]
const mapCenter = [-21.099285, 55.480270]

let markersCluster = {
    parentGroup: null,
    subGroups: {
        "Diagonale des Fous": null,
        "Mascareignes": null,
        "Trail de Bourbon": null,
        "Zembrocal Trail": null,
        "Metis Trail": null
    }
}
let currentIdDossard = null
let dataMultipleRunner = null
let dataOneRunner = null
let randomRunnerLatLng = null
let tracingOfCurrentRouteRunner = null
let refSetTimeoutMultipleRunner = null
let refSetTimeoutOneRunner = null
let racesTracingLayers = []
let startingFlagLayers = []
//let refreshMapInterval = 300000 //mettre 300000 pour 5 minutes
let currentMapMode = "trackingMultipleRunner"
let mapIsInit = false
let flyIsInit = false
let maxRowsRankingTable = 10
//-- Sources de donnees, fixees a la compilation (fichiers .env / .env.grb) :
//--   VUE_APP_POSITION_URL  prefixe des fichiers de position ; relatif = meme domaine
//--                         que le front. Peut finir par "?f=" (position.php sur grb.sfr.re).
//--   VUE_APP_TILES_URL     tuiles du fond de carte, en absolu : elles n'existent que
//--                         sur grandraid.sfr.re.
//-- Les valeurs de repli reproduisent l'ancien comportement (tout sur le domaine courant).
const POSITION_URL = process.env.VUE_APP_POSITION_URL || '/position/'
const TILES_URL = process.env.VUE_APP_TILES_URL || (window.location.origin + '/osmfr/v2/osm_tiles/webp/{z}_{x}_{y}.webp')
function urlPosition(fichier){ return POSITION_URL + fichier }



//-- Normalisation pour la recherche : majuscules, accents supprimes, apostrophes
//-- typographiques et tirets unifies. Meme logique que normaliser() de
//-- PanelCommandeStep0.vue (tunnel de commande) : sans elle, "L'HELGOUALC'H" saisi
//-- avec une apostrophe droite ne trouvait rien. --
function normaliser(valeur){
    return (valeur === null || valeur === undefined ? '' : valeur).toString()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u2018\u2019\u02BC\u0060\u00B4]/g, "'")
        .replace(/[\u2010\u2011\u2012\u2013\u2014]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase()
}

//-- Toutes les formes sous lesquelles un coureur peut etre cherche : le champ entier,
//-- le champ sans ponctuation, et chacun de ses mots. C'est ce qui permet de trouver
//-- "LE HOUE" en tapant "houe", et "L'HELGOUALCH" en tapant "lhelgoualch". --
function motsCherchables(){
    const mots = new Set()
    Array.prototype.forEach.call(arguments, function(valeur){
        const n = normaliser(valeur)
        if(!n) return
        mots.add(n)
        mots.add(n.replace(/[\s'-]/g, ''))
        n.split(/[\s'-]+/).forEach(function(m){ if(m) mots.add(m) })
    })
    return Array.from(mots)
}

//-- Les coureurs sont enregistres en MAJUSCULES depuis 2026. CSS text-transform:capitalize
//-- ne met que l'initiale en capitale sans minusculiser le reste : "ROMAIN" restait "ROMAIN".
//-- On remet donc la casse en JavaScript. --
function capitaliser(valeur){
    const texte = (valeur === null || valeur === undefined ? '' : valeur).toString().toLowerCase()
    let resultat = '', debutDeMot = true
    for (const c of texte) {
        resultat += debutDeMot ? c.toUpperCase() : c
        debutDeMot = (c === ' ' || c === '-' || c === "'" || c === '\u2019')
    }
    return resultat
}

const markersByClass = {};
/*const customIcon = L.icon({
    iconUrl: 'assets/img/blueMarker.svg', // Chemin vers votre image PNG
    iconSize: [38, 38], // Taille de l'icône
    iconAnchor: [19, 38], // Point de l'icône qui correspond à la position du marqueur
    popupAnchor: [0, -38] // Point de l'icône où la popup sera ancrée
});*/

// Exemple de points GPS avec latitude, longitude et un message popup
const pointsGPS = [
    // --- Diagonale des Fous (trace-GR2026.gpx) ---
    { lat: -21.33975, lng: 55.45966, popupText: "Saint-Pierre - Ravine Blanche", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.31265, lng: 55.54592, popupText: "Domaine Vidot", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.24573, lng: 55.59401, popupText: "Notre Dame de la Paix", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.20111, lng: 55.62095, popupText: "Nez de Boeuf", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.16196, lng: 55.57101, popupText: "Mare à Boue", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.12771, lng: 55.50667, popupText: "Coteau Kerveguen", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.11114, lng: 55.49532, popupText: "Croisée Coteau Kerveguen", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.06061, lng: 55.53594, popupText: "Gîte de Bélouve", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.06980, lng: 55.52046, popupText: "Hell-Bourg - Stade Paul Dominique Hubert", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.06613, lng: 55.45102, popupText: "Plaine des Merles", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.05495, lng: 55.45452, popupText: "Départ sentier Scout", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.03868, lng: 55.40988, popupText: "Grand Place les bas - Ecole", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.07392, lng: 55.40055, popupText: "Roche Plate - Plateau Cerf", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -21.05095, lng: 55.38093, popupText: "Maïdo - Tête Dure", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.97280, lng: 55.32685, popupText: "Ilet Savannah", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.96243, lng: 55.35695, popupText: "Chemin Ratinaud", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.93886, lng: 55.33109, popupText: "La Possession - Place Festival", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.89630, lng: 55.37696, popupText: "Grande Chaloupe", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.90825, lng: 55.42363, popupText: "Colorado", className: "ravitos_grr", customIcon: "yellowMarker.svg" },
    { lat: -20.88499, lng: 55.44212, popupText: "Arrivée - Stade de La Redoute", className: "ravitos_grr", customIcon: "yellowMarker.svg" },

    // --- Trail de Bourbon (trace-TDB2026.gpx) ---
    { lat: -21.13630, lng: 55.47418, popupText: "Départ Cilaos", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.10369, lng: 55.43390, popupText: "Marla", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.06614, lng: 55.45103, popupText: "Plaine des Merles", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.05495, lng: 55.45437, popupText: "Départ Sentier Scout", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.03885, lng: 55.40992, popupText: "Grand Place - école", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.07397, lng: 55.40062, popupText: "Roche plate - Plateau Cerf", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -21.05088, lng: 55.38084, popupText: "Maïdo - Tête Dure", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.97276, lng: 55.32684, popupText: "ILET SAVANNAH", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.96245, lng: 55.35702, popupText: "Ratinaud", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.93877, lng: 55.33091, popupText: "La Possession - Place Festival", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.89639, lng: 55.37690, popupText: "Grande Chaloupe", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.90845, lng: 55.42354, popupText: "Colorado", className: "ravitos_tdb", customIcon: "blueMarker.svg" },
    { lat: -20.88489, lng: 55.44269, popupText: "Arrivée Stade de La Redoute", className: "ravitos_tdb", customIcon: "blueMarker.svg" },

    // --- Mascareignes (trace-MAS2026.gpx) ---
    { lat: -21.06976, lng: 55.52097, popupText: "Hell-Bourg -Salazie : km 0", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -21.06617, lng: 55.45102, popupText: "Plaine des Merles", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -21.05434, lng: 55.45448, popupText: "RF départ Sentier Scout", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -21.02627, lng: 55.42815, popupText: "Ilet à Malheur - école", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -21.00317, lng: 55.39252, popupText: "Deux Bras/Rivière des Galets", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.97958, lng: 55.36950, popupText: "Dos d'Ane", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.96246, lng: 55.35698, popupText: "Chemin Ratinaud", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.93874, lng: 55.33139, popupText: "La Possession - Place Festival", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.89579, lng: 55.37722, popupText: "La Grande Chaloupe", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.90802, lng: 55.42364, popupText: "Colorado", className: "ravitos_mas", customIcon: "greenMarker.svg" },
    { lat: -20.88506, lng: 55.44212, popupText: "Stade de la Redoute - KM 74", className: "ravitos_mas", customIcon: "greenMarker.svg" },

    // --- Zembrocal Trail (trace-ZEM2026.gpx) ---
    { lat: -21.37883, lng: 55.61895, popupText: "Place de la Mairie St Joseph", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.30998, lng: 55.64017, popupText: "Grand Galet Ecole", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.23164, lng: 55.64857, popupText: "Pas de Sable", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.20096, lng: 55.62103, popupText: "Parking aire Nez de Bœuf", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.16102, lng: 55.57087, popupText: "Mare à Boue", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.11113, lng: 55.49537, popupText: "Croisée Coteau Kerveguen", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.06067, lng: 55.53593, popupText: "Gîte de Bélouve", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.06980, lng: 55.52052, popupText: "Hell-Bourg - Stade Paul Dominique Hubert", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.06622, lng: 55.45097, popupText: "Plaine des Merles", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.05488, lng: 55.45443, popupText: "Départ Sentier Scout", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -21.03871, lng: 55.40979, popupText: "Grand Place les bas - Ecole", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.97276, lng: 55.32685, popupText: "Ilet Savannah", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.96724, lng: 55.33515, popupText: "Stade Guillaume Adolphe - Halte-là", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.96244, lng: 55.35700, popupText: "Chemin Ratinaud", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.93874, lng: 55.33138, popupText: "La Possession - Place Festival", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.89632, lng: 55.37691, popupText: "La Grande Chaloupe", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.90831, lng: 55.42358, popupText: "Colorado", className: "ravitos_zem", customIcon: "redMarker.svg" },
    { lat: -20.88497, lng: 55.44234, popupText: "La Redoute", className: "ravitos_zem", customIcon: "redMarker.svg" },

    // --- Metis Trail (trace-METIS2026.gpx) ---
    { lat: -21.01589, lng: 55.26093, popupText: "Saint-Paul - Grotte du Peuplement", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -21.01741, lng: 55.30368, popupText: "Ecole de Bellemène", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.97278, lng: 55.32685, popupText: "Ilet Savannah", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.96240, lng: 55.35697, popupText: "Chemin Ratinaud", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.93891, lng: 55.33105, popupText: "La Possession - Place Festival", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.89588, lng: 55.37729, popupText: "Grande Chaloupe", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.90200, lng: 55.40428, popupText: "Saint Bernard - Les Bambous", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.90836, lng: 55.42362, popupText: "Colorado", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.88485, lng: 55.43387, popupText: "Belvédère de La Vigie", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
    { lat: -20.88497, lng: 55.44234, popupText: "Saint-Denis - Stade de La Redoute", className: "ravitos_mtr", customIcon: "metisMarker.svg" },
];




const raceConfigs = [
    {
        idConfig: "Mascareignes",
        markerPopupTitle: 'LA MASCAREIGNES',
        gpxURL: 'assets/gpx/trace-MAS2026.gpx',
        color: '#669232',
        outlineColor: '#126F16',
        class: 'gr-mas',
        classText: 'gr-text-mas',
        classbg: 'gr-bg-mas',
        strokeWidth: 5,
        startingRace: {
            flag: 'assets/img/starting-flag.svg',
            position: {
                lat: -21.06976,
                long: 55.52097
            }

        },
        endingRace: {
            flag: 'assets/img/ending-flag.svg',
            position: {
                lat: -20.88506,
                long: 55.44212
            }

        }
    },
    {
        idConfig: "Trail de Bourbon",
        markerPopupTitle: 'TRAIL DE BOURBON',
        gpxURL: 'assets/gpx/trace-TDB2026.gpx',
        color: '#585FAB',
        outlineColor: '#222760',
        class: 'gr-tdb',
        classText: 'gr-text-tdb',
        classbg: 'gr-bg-tdb',
        strokeWidth: 5,
        startingRace: {
            flag: 'assets/img/starting-flag.svg',
            position: {
                lat: -21.13630,
                long: 55.47418
            }

        },
        endingRace: {
            flag: 'assets/img/ending-flag.svg',
            position: {
                lat: -20.88489,
                long: 55.44269
            }

        }
    },
    {
        idConfig: "Zembrocal Trail",
        markerPopupTitle: 'ZEMBROCAL TRAIL',
        gpxURL: 'assets/gpx/trace-ZEM2026.gpx',
        color: '#D12E26',
        outlineColor: '#851913',
        class: 'gr-zem',
        classText: 'gr-text-zem',
        classbg: 'gr-bg-zem',
        strokeWidth: 5,
        startingRace: {
            flag: 'assets/img/starting-flag.svg',
            position: {
                lat: -21.37883,
                long: 55.61895
            }

        },
        endingRace: {
            flag: 'assets/img/ending-flag.svg',
            position: {
                lat: -20.88497,
                long: 55.44234
            }

        }
    },
    {
        idConfig: "Diagonale des Fous",
        markerPopupTitle: 'DIAGONALE DES FOUS',
        gpxURL: 'assets/gpx/trace-GR2026.gpx',
        color: '#F7CF45',
        outlineColor: '#9F8119',
        class: 'gr-ddf',
        classText: 'gr-text-ddf',
        classbg: 'gr-bg-ddf',
        strokeWidth: 5,
        startingRace: {
            flag: 'assets/img/starting-flag.svg',
            position: {
                lat: -21.33975,
                long: 55.45966
            }

        },
        endingRace: {
            flag: 'assets/img/ending-flag.svg',
            position: {
                lat: -20.88499,
                long: 55.44212
            }
        }
    },
    {
        idConfig: "Metis Trail",
        markerPopupTitle: 'METIS TRAIL',
        gpxURL: 'assets/gpx/trace-METIS2026.gpx',
        color: '#518fc9',
        outlineColor: '#264766',
        class: 'gr-metis',
        classText: 'gr-text-metis',
        classbg: 'gr-bg-metis',
        strokeWidth: 5,
        startingRace: {
            flag: 'assets/img/starting-flag.svg',
            position: {
                lat: -21.01589,
                long: 55.26093
            }

        },
        endingRace: {
            flag: 'assets/img/ending-flag.svg',
            position: {
                lat: -20.88497,
                long: 55.44234
            }
        }
    }
]

//-- Initialization --
function init(){
    //console.log('init');
    initSessionStorage()
    initEventsListeners()
    initRefreshingMap()
    initRaceFilteringOverlay()
}

//-- Initialization of the session data --
function initSessionStorage(){
    
    if(sessionStorage.getItem('grData')){
        currentMapMode = JSON.parse(sessionStorage.getItem('grData')).currentMapMode
        currentIdDossard = JSON.parse(sessionStorage.getItem('grData')).currentIdDossard
    } else{
        const data = JSON.stringify({ currentIdDossard: currentIdDossard, currentMapMode: currentMapMode })
        sessionStorage.setItem('grData', data);
    }
    
}
function initContentCoureur(){
    //-- Init runner card color --
    initCardRunnerColor()

    //-- Init runner card content --
    let nomCourse = document.querySelector("#gr-fiche-coureur-panel .gr-fiche-coureur-card h1");
    let nomCourse2 = document.querySelector("#gr-fiche-coureur-panel > h1");
    while (nomCourse.firstChild) {
        nomCourse.removeChild(nomCourse.lastChild);
    }
    while (nomCourse2.firstChild) {
        nomCourse2.removeChild(nomCourse2.lastChild);
    }
    let lenomcourse = dataOneRunner.info[currentIdDossard].infos.course+" ";
    let lenomcourse2 = dataOneRunner.info[currentIdDossard].infos.course+" " ;
    if(dataOneRunner.info[currentIdDossard].infos.categorie!=''&&dataOneRunner.info[currentIdDossard].infos.categorie!=null){
      lenomcourse+= dataOneRunner.info[currentIdDossard].infos.categorie ;
      lenomcourse2+= dataOneRunner.info[currentIdDossard].infos.categorie ;
    }
    let textnomcourse = document.createTextNode(lenomcourse );
    let textnomcourse2 = document.createTextNode(lenomcourse2 );
    nomCourse.appendChild(textnomcourse);
    nomCourse2.appendChild(textnomcourse2);
    let nomcoureur = document.querySelector(".gr-fiche-nom");
    Array.from(nomcoureur.children).forEach( child => child.remove())
    let spannom = document.createElement("span");
    spannom.classList.add('uk-text-uppercase')
    let spanprenom = document.createElement("span");
    let textnom = document.createTextNode(dataOneRunner.info[currentIdDossard].infos.nom);
    let textprenom = document.createTextNode(capitaliser(dataOneRunner.info[currentIdDossard].infos.prenom));
    spannom.appendChild(textnom);
    spanprenom.appendChild(textprenom);
    nomcoureur.append(spanprenom, ' ', spannom);

    let classementcoureur = document.querySelector(".gr-fiche-classement span");
    let spanclassement = document.createElement("span");
    let textclassement = document.createTextNode("#"+dataOneRunner.info[currentIdDossard].infos.clt);
    spanclassement.appendChild(textclassement);
    classementcoureur.replaceWith(spanclassement);

    let ndossardcoureur = document.querySelector(".gr-fiche-dossard span");
    let spanndossard = document.createElement("span");
    let textndossard = document.createTextNode(dataOneRunner.info[currentIdDossard].id_dossard);
    spanndossard.appendChild(textndossard);
    ndossardcoureur.replaceWith(spanndossard);

    let etatcoureur = document.querySelector(".gr-fiche-etat span");
    let spannetat = document.createElement("span");
    let textetat = document.createTextNode(dataOneRunner.info[currentIdDossard].infos.etat);
    spannetat.appendChild(textetat);
    etatcoureur.replaceWith(spannetat);

    //-- Coureur sans balise GPS : encart dans la fiche et libelle de la carte adapte --
    const infosCoureur = dataOneRunner.info[currentIdDossard].infos
    const encartSansBalise = document.querySelector('.gr-fiche-sans-balise')
    const labelCarte = document.querySelector('.gr-fiche-coureur-info-label')
    if(encartSansBalise){
      if(infosCoureur.sansBalise){
        encartSansBalise.querySelector('p').textContent = "Ce coureur n'est pas équipé d'une balise GPS. Sa position sur la carte est celle de son dernier point de passage" + (infosCoureur.nomEtape ? ' (' + infosCoureur.nomEtape + ')' : '') + ", ce n'est pas une position en temps réel."
        encartSansBalise.classList.remove('uk-hidden')
      } else {
        encartSansBalise.classList.add('uk-hidden')
      }
    }
    if(labelCarte) labelCarte.textContent = infosCoureur.sansBalise ? 'POSITION AU DERNIER POINT DE PASSAGE' : 'POSITION EN TEMPS RÉEL'

    let lastpassagecoureur = document.querySelector(".gr-last-passage");
    while (lastpassagecoureur.firstChild) {
        lastpassagecoureur.removeChild(lastpassagecoureur.lastChild);
    }
    let spanpassage1 = document.createElement("span");
    spanpassage1.classList.add("uk-margin-small-right");

    let lastpassage = dataOneRunner.info[currentIdDossard].pointage[dataOneRunner.info[currentIdDossard].pointage.length-1];

    if(lastpassage){
        let textpassage1 = document.createTextNode(lastpassage.datePassage);
        spanpassage1.appendChild(textpassage1);
        lastpassagecoureur.appendChild(spanpassage1);

        let spanpassage2 = document.createElement("span");
        if(lastpassage.nompointage){
            let textpassage2 = document.createTextNode(lastpassage.nompointage);
            spanpassage2.appendChild(textpassage2);
            lastpassagecoureur.appendChild(spanpassage2);
        }
    } else {
        const message = document.createTextNode('Aucun résultat.')
        lastpassagecoureur.appendChild(message)
    }


    let tablePassage = document.querySelector("table.gr-fiche-coureur-table tbody");
    while (tablePassage.firstChild) {
        tablePassage.removeChild(tablePassage.lastChild);
    }
    let objtr =  document.createElement("tr");
    let objtd1 = document.createElement("td");
    let objtd2 = document.createElement("td");
    objtd2.classList.add("uk-text-center");

    const pointages = dataOneRunner.info[currentIdDossard].pointage

    if( pointages.length != 0 ){
        pointages.forEach(function(item){
            let tr1 = objtr.cloneNode(false);
            let td1 = objtd1.cloneNode(false);
            let texttd1 = document.createTextNode("");
            if(item.nompointage){
                texttd1 = document.createTextNode(item.nompointage);
            }
            td1.appendChild(texttd1);
            tr1.appendChild(td1);
            let td2 = objtd2.cloneNode(false);
            let texttd2 = document.createTextNode(item.tempscourse);
            td2.appendChild(texttd2);
            tr1.appendChild(td2);
            let td3 = objtd2.cloneNode(false);
            let texttd3 = document.createTextNode(item.clt);
            td3.appendChild(texttd3);
            tr1.appendChild(td3);
            tablePassage.appendChild(tr1);
        });
    } else {
        const message = document.createTextNode('Aucun résultat.')
        tablePassage.appendChild(objtr)
        objtr.appendChild(objtd1)
        objtd1.appendChild(message)
        objtd1.setAttribute('colspan', '3')
        objtd1.classList.add('uk-text-center')
    }

}

function initCardRunnerColor(){
    const currentRace = dataOneRunner.info[currentIdDossard].infos.course
    const borderElement = document.querySelector('#gr-fiche-coureur-panel .gr-suivi-coureur-border')
    const backgroundElement = document.querySelector('#gr-fiche-coureur-panel .gr-suivi-coureur-background')

    raceConfigs.forEach( race => {
        const currentRaceSelector = race.idConfig.split(' ').join('-').toLowerCase()
        const borderClass = 'gr-suivi-coureur-border-left-'+currentRaceSelector
        const backgroundClass = 'gr-suivi-coureur-background-'+currentRaceSelector

        currentRace == race.idConfig ? borderElement.classList.add(borderClass) : borderElement.classList.remove(borderClass)
        currentRace == race.idConfig ? backgroundElement.classList.add(backgroundClass) : backgroundElement.classList.remove(backgroundClass)

    })
}

function initPanel(){
    if(currentMapMode == 'trackingMultipleRunner'){
        //-- Hide panel fiche coureur --
        document.querySelector("#gr-fiche-coureur-panel-container").style.display = "none"
        document.querySelector(".li-infos-coureur").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.openInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.openInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.closeInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.closeInfos").classList.add('uk-hidden')
        //-- Show suivi coureur panel (celui avec le dégradé bleu) --
        document.querySelector("#gr-suivi-coureur-container").style.display = "flex"
        document.querySelector("#gr-section-marla").style.display = "block"
    }
    if(currentMapMode == 'trackingOneRunner'){
        initContentCoureur();
        //-- Show panel fiche coureur --
        document.querySelector("#gr-fiche-coureur-panel-container").style.display = "block"
        document.querySelector(".li-infos-coureur").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.openInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.openInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.closeInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.closeInfos").classList.remove('uk-hidden')
        //-- Hide suivi coureur panel (celui avec le dégradé bleu) --
        document.querySelector("#gr-suivi-coureur-container").style.display = "none"
        document.querySelector("#gr-section-marla").style.display = "none"
    }
}

//-- Initialization of the events listeners --
function initEventsListeners(){
  document.querySelector('.gr-suivi-coureur-cta-brand').addEventListener('click',()=>handleClickHome());
    document.querySelector("#gr-suivi-coureur-toggle-map").addEventListener('click', () => handleClickToogleMap())
    document.querySelector("#gr-suivi-coureur-ranking-see-map-button").addEventListener('click', () => handleClickToogleMap())
    document.querySelector("#gr-fiche-coureur-toggle-panel").addEventListener('click', (e) => handleClickToogleMapRunnerDesktop(e, 'desktop'))
    document.querySelector(".gr-fiche-coureur-toggle-panel-mobile").addEventListener('click', (e) => handleClickToogleMapRunnerDesktop(e, 'mobile'))
    document.querySelector("#gr2022-infos-coureur-button-mobile").addEventListener('click',  (e) => handleClickToogleMapRunnerDesktop(e, 'mobile'))
    document.querySelector("#gr2022-filter-button-mobile").addEventListener('click', () => {
        document.querySelector("#gr-race-filtering-overlay").classList.toggle('open-filter-mobile')
        document.querySelector("#gr-pointsravitos").classList.toggle('open-filter-mobile')
    })

    //----- CHANGE THE MAP ON TRACKING MULTIPLE RUNNERS -----
    //-- Left logo on the header --
    document.querySelector(".gr-nav-container .uk-navbar-left").addEventListener('click',(e) => handleChangeMap(e) )
    //-- Raccourcis Messenger / Oté Mafate du header. Deux pieges ici :
    //--  1. ils sont dans .uk-navbar-left, dont tout clic relance un reset de la carte
    //--     (handleChangeMap) -> stopPropagation ;
    //--  2. un href="#bloc-..." change le hash, et vue-router (mode hash) navigue vers
    //--     une route /bloc-... inexistante : la page se demonte. uk-scroll de UIkit
    //--     n'intercepte pas le clic ici (contrairement a gr2022-phase-2) -> on fait
    //--     le defilement nous-memes, en tenant compte du header fixe. --
    document.querySelectorAll(".gr-nav-container .gr-logo-raccourci").forEach( lien => {
        lien.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            const cible = document.querySelector(lien.getAttribute('href'))
            if(!cible) return
            const header = document.querySelector('.gr-nav-container')
            const decalage = header ? header.getBoundingClientRect().height : 0
            window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - decalage, behavior: 'smooth' })
        })
    })
    //-- Button "suivre la course" Desktop --
    document.querySelector("#button-suivre-la-course").addEventListener('click',(e) => handleChangeMap(e) )
    //-- Button "suivre la course" Mobile --
    document.querySelector("#button-suivre-la-course-mobile").addEventListener('click',(e) => handleChangeMap(e) )
}


//-- Initialization of the map --
function initMap(){
    let innerWidthCondition = window.innerWidth >= 1440
    let zoominitial = 10;
    if(innerWidthCondition){
      zoominitial = 11;
    }
    //-- Prevent tiles loading thanks to an area --
    var southWest = L.latLng(-21.389256, 55.216414),
        northEast = L.latLng(-20.871859, 55.836273),
        mybounds = L.latLngBounds(southWest, northEast);

    //-- Init the map --
    map = L.map('gr-suivi-coureur-map', {
        renderer: L.svg(),
        center: mapCenter,
        zoom: zoominitial,
        gestureHandling: true,
        gestureHandlingOptions: {
            duration: 3000 //3 secs
        }
    })

    //-- Load the map from tiles --
    // TODO Change the url to prod
    // https://gr2022.digital1to1.fr/osmfr/{z}_{x}_{y}.png - DEV
    // https://grandraid.sfr.re/osmfr/{z}_{x}_{y}.png - PROD
    L.tileLayer(TILES_URL, {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        minZoom: 10,
        maxZoom: 18,
        bounds: mybounds
    }).addTo(map)

    //-- Change the position of the zoom control --
    map.zoomControl.setPosition('topright')

    //-- Tracing race depending of the current map mode --
    tracingRaces()

    //-- Place on the map starting flag and ending flag --
    placeStartingEndingFlags()

    mapIsInit = true

    window.addEventListener('wheel', () => adjusingtMessageOverlayMap() )
    window.addEventListener('touchmove', () => {
        adjusingtMessageOverlayMap()
    } )

    adjustingAlignementInfoLabel()

    window.addEventListener('resize', () => adjustingAlignementInfoLabel())

    debugProblemZoomButtonOnMobile()
    fixProblemMapHeight()





    // Ajout des points GPS sur la carte avec icône personnalisée et popup formatée
    pointsGPS.forEach(point => {

        // Icone a la couleur de la course (cf. customIcon de pointsGPS) ;
        // blackMarker reste le repli si le point n'en declare pas.
        const iconClassName = point.customIcon || 'blackMarker.svg';
        const customIcon = L.icon({
            iconUrl: `assets/img/${iconClassName}`, // Le chemin vers l'icône dépendra du nom de className
            iconSize: [38, 38], // Taille de l'icône
            iconAnchor: [19, 38], // Point de l'icône qui correspond à la position du marqueur
            popupAnchor: [0, -38] // Point de l'icône où la popup sera ancrée
        });

        const marker = L.marker([point.lat, point.lng], { icon: customIcon });

        // Structure HTML personnalisée pour le contenu de la popup
        const popupContent = `<div class="leaflet-popup-content" style="width: 222px;">
                                <div class="gr-popup-ravitos">${point.popupText}</div>
                              </div>`;

        if (point.popupText) {
            marker.bindPopup(popupContent);
        }

        // Ajouter le marqueur à l'objet markersByClass selon la classe
        if (!markersByClass[point.className]) {
            markersByClass[point.className] = [];
        }
        markersByClass[point.className].push(marker);
    });

    // Écouter le changement d'état de toutes les checkbox avec la classe `togglePoints`
    document.querySelectorAll('.togglePoints').forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            const checked = this.checked;
            const className = this.getAttribute('data-class'); // Récupère la classe associée

            if (markersByClass[className]) {
                markersByClass[className].forEach(marker => {
                    if (checked) {
                        marker.addTo(map);
                    } else {
                        map.removeLayer(marker);
                    }
                });
            }
        });
    });





}

function initRaceFilteringOverlay(){
    const checkboxs = document.querySelectorAll("#gr-race-filtering-overlay input[type='checkbox']")

    //-- Init the checkbox to the current session data --
    const sessionData = JSON.parse(sessionStorage.getItem('grData'))
    if(Object.prototype.hasOwnProperty.call(sessionData,'raceFiltering')){
        checkboxs.forEach( checkbox => {
            const courseId = checkbox.getAttribute('data-race')
            //-- une cle absente (session anterieure au correctif "Metiss Trail") = course affichee --
            checkbox.checked =  sessionData.raceFiltering[courseId] !== false

            //-- Init hightlighting filter --
            if(!checkbox.checked) checkbox.closest('li').classList.toggle('active')
        })
    }

    //-- Add event on each checkboxs --
    checkboxs.forEach( checkbox => checkbox.addEventListener('change', (e) => handleChange(e)) )

    //-- Event Handler --
    const handleChange = (e) => {
        const racesToShow = []
        const sessionData = { raceFiltering: {} }

        //-- Change the higthlighting --
        e.currentTarget.closest("li").classList.toggle('active')

        checkboxs.forEach( checkbox => {
            const raceId = checkbox.getAttribute('data-race')

            const sousGroupe = markersCluster.subGroups[raceId]
            if(checkbox.checked){
                if(sousGroupe) map.addLayer(sousGroupe)
                racesToShow.push(raceId)
            } else {
                if(sousGroupe) map.removeLayer(sousGroupe)
            }

            //-- Stock session data in local var --
            sessionData.raceFiltering[raceId] = checkbox.checked
        })

        //-- Set the current race filtering in session storage --
        setSessionStorage(sessionData)

        //-- Show race depending the filtering --
        showRaces(racesToShow)
    }

    //-- Hide race filtering overlay on tracking one runner --
    if(currentMapMode == "trackingOneRunner") hideRaceFilteringOverlay()
}

function hideRaceFilteringOverlay(){
    document.querySelector("#gr-race-filtering-overlay").style.display = "none"
    document.querySelector("#gr-pointsravitos").style.display = "none"
}

function showRaceFilteringOverlay(){
    document.querySelector("#gr-race-filtering-overlay").style.display = "block"
    document.querySelector("#gr-pointsravitos").style.display = "block"
}

function adjusingtMessageOverlayMap(){
    let innerWidthCondition, container, containerIsOpen, rightCenterClass
    const mapOverlayMessageDesktop = document.querySelector(".leaflet-gesture-handling-scroll-warning")
    const mapOverlayMessageMobile = document.querySelector(".leaflet-gesture-handling-touch-warning")
    const mapOverlayMessage = mapOverlayMessageDesktop ? mapOverlayMessageDesktop : mapOverlayMessageMobile
    const oneRunnerRightCenterClass = "gr-fiche-coureur-overlay-map-message-right-center"
    const multipleRunnerRightCenterClass = "gr-fiche-coureur-overlay-map-message-multiple-runner-right-center"
    const centerClass = "gr-fiche-coureur-overlay-map-message-center"

    //-- Set local vars depending of the current map mode --
    if(currentMapMode == 'trackingMultipleRunner'){
        innerWidthCondition = window.innerWidth > 640
        container = document.querySelector("#gr-suivi-coureur-container")
        containerIsOpen = container.classList.contains("gr-suivi-coureur-map-close")
        rightCenterClass = multipleRunnerRightCenterClass
    } else {
        innerWidthCondition = window.innerWidth >= 960
        container = document.querySelector("#gr-fiche-coureur-panel-container")
        containerIsOpen = container.classList.contains("gr-fiche-coureur-open-panel")
        rightCenterClass = oneRunnerRightCenterClass
    }


    if(mapOverlayMessage){
        //-- Clear class before add new --
        mapOverlayMessage.classList.remove(centerClass)
        mapOverlayMessage.classList.remove(rightCenterClass)
        mapOverlayMessage.classList.remove(multipleRunnerRightCenterClass)

        //-- Align map overlay message --
        if(innerWidthCondition) {
            containerIsOpen ? mapOverlayMessage.classList.add(rightCenterClass) : mapOverlayMessage.classList.add(centerClass)
        } else if(currentMapMode == 'trackingMultipleRunner') {
            mapOverlayMessage.classList.add(centerClass)
        }
    }
}

function adjustingAlignementInfoLabel(){
    let container, containerIsOpen, innerWidthCondition, rightCenterClass
    const infoLabel = document.querySelector(".gr-fiche-coureur-info-label")
    const rightCenterClassMultipleRunner = "gr-fiche-coureur-info-label-right-center-multiple-runner"
    const rightCenterClassOneRunner = "gr-fiche-coureur-info-label-right-center-one-runner"

    //-- Set local vars depending the current map mode --
    if(currentMapMode == 'trackingMultipleRunner'){
        container = document.querySelector("#gr-suivi-coureur-container")
        containerIsOpen = container.classList.contains('gr-suivi-coureur-map-close')
        innerWidthCondition = window.innerWidth > 640
        rightCenterClass = rightCenterClassMultipleRunner
    } else {
        container = document.querySelector("#gr-fiche-coureur-panel-container")
        containerIsOpen = container.classList.contains('gr-fiche-coureur-open-panel')
        innerWidthCondition = window.innerWidth >= 960
        rightCenterClass = rightCenterClassOneRunner
    }

    //-- Clear class before add new --
    infoLabel.classList.remove(rightCenterClassOneRunner)
    infoLabel.classList.remove(rightCenterClassMultipleRunner)

    //-- Align info label : "Position en temps réel" --
    if(innerWidthCondition && containerIsOpen) infoLabel.classList.add(rightCenterClass)
}

function adjustingMapCenter() {
    let panel, panelOpenClass, currentRunnerLatLng, breakpointCondition
    //-- If is the first init of the map then choose a random runner --
    if (randomRunnerLatLng == null){
        /*const data = Object.values(dataMultipleRunner.info)
        const min = 0
        const max = data.length
        const randomIndexOfRunner = Math.floor(Math.random() * (max - min) + min)
        //-- Save the random runner to a global var --
        randomRunnerLatLng = L.latLng(data[randomIndexOfRunner].dernierePosition.lat, data[randomIndexOfRunner].dernierePosition.long)
        */
        randomRunnerLatLng = L.latLng(mapCenter[0],mapCenter[1]);
    }

    //-- Set local vars depending of the current map mode --
    if (currentMapMode == 'trackingMultipleRunner') {
        panel = document.querySelector("#gr-suivi-coureur-container")
        panelOpenClass = "gr-suivi-coureur-map-close"
        currentRunnerLatLng = randomRunnerLatLng
        breakpointCondition = window.innerWidth > 640
    } else {
        panel = document.querySelector("#gr-fiche-coureur-panel-container")
        panelOpenClass = "gr-fiche-coureur-open-panel"
        currentRunnerLatLng = L.latLng(dataOneRunner.info[currentIdDossard].dernierePosition.lat, dataOneRunner.info[currentIdDossard].dernierePosition.long)
        breakpointCondition = window.innerWidth >= 960
    }

    // -- If the left panel is open, then center the map on the right remaining space --
    if (breakpointCondition && panel.classList.contains(panelOpenClass)) {
        const rightOffset = (0.5 * window.innerWidth) - (0.5 * (window.innerWidth - panel.offsetWidth))
        //-- Convert lat long to pixel --
        const randomRunnerPoint = map.project(currentRunnerLatLng, map.getZoom())
        //-- Add the right offset --
        randomRunnerPoint.x = randomRunnerPoint.x - rightOffset
        //-- Convert the new point to latlong --
        currentRunnerLatLng = map.unproject(randomRunnerPoint, map.getZoom())
    }

    //-- Move the map to the random runner the lat lng coordinate --

    //console.log('fly?');
    if(!flyIsInit) {
      //console.log('fly');
      map.flyTo(currentRunnerLatLng)
      flyIsInit = true;
    }
}

function debugProblemZoomButtonOnMobile(){
    const zoomButtons = document.querySelectorAll('.leaflet-control-zoom-in, .leaflet-control-zoom-out')

    zoomButtons.forEach( button => {
        button.addEventListener('click', () =>  window.scrollTo(0,0) )
    })
}



function setSessionStorage(obj){
    const currentSessionData = JSON.parse(sessionStorage.getItem('grData'))
    const data = Object.assign(currentSessionData, obj)
    sessionStorage.setItem('grData', JSON.stringify(data));
}

//-- Use to retrieve data runners each "refreshMapInterval" --
async function initRefreshingMap(){
    if(currentMapMode == 'trackingMultipleRunner') refreshingDataOnTrackingMultipleRunner()
    if(currentMapMode == 'trackingOneRunner') refreshingDataOnTrackingOneRunner()

}

function refreshingDataOnTrackingMultipleRunner(){
    //const isFirstInitData = dataMultipleRunner === null
    let apiRoute = urlPosition('lescoureurs.json')
    let formdata = null

    //-- If is not the first initialization of data runners --
    /*if(!isFirstInitData) {
        //-- Change the api route if is not the first initalization of the data--
        apiRoute = updatedMultipleRunnerApiRoute

        //-- Pass in param of the request a lastmaj timestamp to retrieve only the updated data --
        formdata = new FormData();
        formdata.append("lastDemande", dataMultipleRunner.lastmaj)
        // formdata.append("lastDemande", 1658254140); // TEST
    }*/

    fetch(apiRoute, {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    })
        .then( response => { return response.json() })
        .then( data => {
            if(data.status == 'succes'){
                //-- Refreshing data of runners  --
                dataMultipleRunner = data
                //isFirstInitData ? dataMultipleRunner = data : updateDataMultipleRunners(data)
                if(dataMultipleRunner.afficheClassement){
                  const afficherobj = document.querySelectorAll(".showclassement")
                  //console.log("afficherobj:",afficherobj);
                  afficherobj.forEach(obj => obj.classList.remove("uk-hidden"))
                }
                else{
                  const afficherobj = document.querySelectorAll(".showclassement")
                  afficherobj.forEach(obj => obj.classList.add("uk-hidden"))
                }
                initPanel()
                if(!mapIsInit){
                    initMap()
                }
                refreshMakersOfRunners()

                adjustingMapCenter()

                //refSetTimeoutMultipleRunner = setTimeout(() => refreshingDataOnTrackingMultipleRunner(), refreshMapInterval)
            } else {
                //-- Pas de positions (fichiers pas encore generes par le cron, dossier illisible...) :
                //-- on affiche quand meme le bloc de texte, le fond de carte, les traces et les
                //-- points d'etape, simplement sans coureur. Avant, rien de tout ca n'apparaissait :
                //-- initPanel() est ce qui rend visibles le panneau "Suivez les coureurs" et la
                //-- section Messenger / Ote Mafate (display:none au chargement). --
                initPanel()
                if(!mapIsInit) initMap()
                //refSetTimeoutMultipleRunner = setTimeout(() => refreshingDataOnTrackingMultipleRunner(), refreshMapInterval)
            }
        })
        //-- Reponse qui n'est pas du JSON (404 Apache, page d'erreur) ou reseau indisponible :
        //-- meme repli, la page s'affiche avec une carte vide plutot que rien. --
        .catch( () => { initPanel(); if(!mapIsInit) initMap() })
        //.catch(() => refSetTimeoutMultipleRunner = setTimeout(() => refreshingDataOnTrackingMultipleRunner(), refreshMapInterval))

}

function refreshingDataOnTrackingOneRunner(){
    const isFirstInitData = dataMultipleRunner === null
    const formdata = new FormData();
    formdata.append("idDossard", currentIdDossard)

    if(isFirstInitData) {
        //-- Retrieve data of multiple runners --
        fetch(urlPosition('lescoureurs.json'))
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.status == 'succes') dataMultipleRunner = data
            })
            .catch( () => {} )   // positions indisponibles : gere par le chargement du coureur ci-dessous
    }

    let fileOneRunner = "d"+currentIdDossard+".json"
    //-- Retrieve data of one runner --
    fetch(urlPosition(fileOneRunner), {
        method: 'GET',
        //body: formdata,
        redirect: 'follow'
    })
        .then( response => { return response.json() })
        .then( data => {
            if(data.status == 'succes'){
                dataOneRunner = data
                if(dataOneRunner.afficheClassement){
                  const afficherobj = document.querySelectorAll(".showclassement")
                  //console.log("afficherobj:",afficherobj);
                  afficherobj.forEach(obj => obj.classList.remove("uk-hidden"))
                }
                else{
                  const afficherobj = document.querySelectorAll(".showclassement")
                  afficherobj.forEach(obj => obj.classList.add("uk-hidden"))
                }
                initPanel()
                if(!mapIsInit) initMap()

                refreshMakersOfRunners()

                adjustingMapCenter()


                //-- Tracing of the current route of the runner --
                const currentRaceConfig = getConfigByRace(dataOneRunner.info[currentIdDossard].infos.course)
                tracingCurrentRouteOfRunner(currentRaceConfig)

                //refSetTimeoutOneRunner = setTimeout(() => refreshingDataOnTrackingOneRunner(), refreshMapInterval)
            } else {
                retourVueGenerale()
                //refSetTimeoutOneRunner = setTimeout(() => refreshingDataOnTrackingOneRunner(), refreshMapInterval)
            }
        })
        .catch( () => retourVueGenerale() )
        //.catch(() => refSetTimeoutOneRunner = setTimeout(() => refreshingDataOnTrackingOneRunner(), refreshMapInterval))

}

//-- Fiche d'un coureur indisponible au chargement de la page (fichier d<dossard>.json absent
//-- ou illisible, par exemple une session qui memorise un coureur alors que les positions ne
//-- sont pas encore generees) : on repasse en vue generale par le meme chemin que le bouton
//-- "Suivre la course", plutot que de laisser la page sans carte. Si la carte est deja la,
//-- on ne change rien a ce que voit le visiteur. --
function retourVueGenerale(){
    if(mapIsInit) return
    const bouton = document.querySelector('#button-suivre-la-course')
    if(bouton) simulateClick(bouton)
}

/*function updateDataMultipleRunners(updatedData){
    //-- Update each data have change --
    Object.values(updatedData.info).forEach( data => {
        dataMultipleRunner.info[data.id_dossard].dernierePosition = data.dernierePosition
        dataMultipleRunner.info[data.id_dossard].infos = data.infos
    })

    //-- Update the lastmaj timestamp --
    dataMultipleRunner.lastmaj = updatedData.lastmaj
}*/

function refreshLayersMap(){
    //----- HIDE ELEMENTS OF THE MAP -----//
    //-- Hide all starting flags --
    startingFlagLayers.forEach( layer => layer._icon.style.display = 'none')

    //----- SHOW ELEMENTS OF THE MAP DEPENDING THE CURRENT MAP -----//
    if(currentMapMode == "trackingMultipleRunner"){
        //-- Show tracing race depending the session data --
        const sessionData = JSON.parse(sessionStorage.getItem('grData'))

        if(Object.prototype.hasOwnProperty.call(sessionData,'raceFiltering')) {
            const racesToShow = Object.entries(sessionData.raceFiltering).map( filter => {
                const [courseId, bool] = filter
                if(bool) return courseId
            })
            showRaces(racesToShow)
        } else{
            //-- Show all tracing races --
            const racesToShow = raceConfigs.map( race => race.idConfig)
            showRaces(racesToShow)
        }

        //-- Show all starting flags --
        startingFlagLayers.forEach( layer => layer._icon.style.display = 'block' )

        showRaceFilteringOverlay()
    }

    if(currentMapMode == "trackingOneRunner") {
        //-- Retrieve the race config of the current runner --
        const currentRace = dataMultipleRunner.info[currentIdDossard].infos.course
        const raceConfig = getConfigByRace(currentRace)

        //-- Show tracing race of the current runner --
        showRaces([currentRace])

        //-- Show the starting flag of the current runner --
        startingFlagLayers.forEach( layer => {
            const latLngLayer = layer._latlng
            const latLngRaceConfig = raceConfig.startingRace.position
            if(latLngLayer.lat === latLngRaceConfig.lat && latLngLayer.lng === latLngRaceConfig.long) layer._icon.style.display = 'block'
        })

        hideRaceFilteringOverlay()
    }
}

//-- Trace race depending the current map mode --
async function tracingRaces(){
    //-- Tracing all of race --
    if( currentMapMode == "trackingMultipleRunner"){
        for (const config of raceConfigs) {
            await tracingOfRace(config.idConfig, config.gpxURL, config.color, config.outlineColor, config.strokeWidth)
        }

        //-- Show the race depending the current filtering race --
        const sessionData = JSON.parse(sessionStorage.getItem('grData'))

        if(Object.prototype.hasOwnProperty.call(sessionData,'raceFiltering')){
            const racesToShow = Object.entries(sessionData.raceFiltering).map( filter => {
                const [courseId, bool] = filter
                if(bool) return courseId
            })

            showRaces(racesToShow)
        }

    }

    //-- Tracing race of the current runner --
    if( currentMapMode == "trackingOneRunner") {
        const currentRaceConfig = getConfigByRace(dataOneRunner.info[currentIdDossard].infos.course)

        for (const config of raceConfigs) {

            const strokeColor = config.idConfig == currentRaceConfig.idConfig ? currentRaceConfig.color : "rgba(0,0,0,0)"
            const outlineColor = config.idConfig == currentRaceConfig.idConfig ? currentRaceConfig.outlineColor : "rgba(0,0,0,0)"
            await tracingOfRace(config.idConfig, config.gpxURL, strokeColor, outlineColor, config.strokeWidth)
        }

        //-- Tracing of the current route of a runner --
        tracingCurrentRouteOfRunner(currentRaceConfig)
    }
}

//-- Trace a race on the map --
async function tracingOfRace(idConfig, gpxURL, strokeColor, outlineColor, strokeWidth){
    const gpxJSON = await convertGpxToJSON(gpxURL)

    //-- On ne garde que le trace. Les GPX 2026 embarquent aussi les points d'etape en
    //-- <wpt> : togeojson les convertit en features Point, que L.geoJson afficherait
    //-- avec le marqueur Leaflet par defaut. Les points d'etape sont deja poses par
    //-- pointsGPS, avec les bonnes icones et la case "Afficher/Masquer". --
    const sansPoints = { filter: function(feature){ return feature.geometry && feature.geometry.type !== 'Point' } }

    //-- Create an object of the layer race --
    const layerRace = {
        idConfig: idConfig,
        layerOutline: L.geoJson(gpxJSON, Object.assign({ color: outlineColor, weight: strokeWidth + 3}, sansPoints)).addTo(map),
        layer: L.geoJson(gpxJSON, Object.assign({ color: strokeColor, weight: strokeWidth}, sansPoints)).addTo(map)
    }

    //-- Put the layer in an array --
    return new Promise(resolve => resolve(racesTracingLayers.push(layerRace)))
}

//-- Tracing of the current route of a runner --
function tracingCurrentRouteOfRunner(currentRaceConfig){
    removeTracingCurrentRouteOfRunner()
    const raceTracing = racesTracingLayers.filter( raceTracing => { return raceTracing.idConfig == currentRaceConfig.idConfig })[0].layer
    const raceTracingLatLng = Object.values(raceTracing._layers)[0]._latlngs
    let currentRunnerPoint = dataOneRunner.info[currentIdDossard].dernierePosition
    currentRunnerPoint = L.latLng(currentRunnerPoint.lat, currentRunnerPoint.long)
    const distancesPointMarker = []

    for (const index in raceTracingLatLng) {
        const point = L.latLng(raceTracingLatLng[index].lat, raceTracingLatLng[index].lng);
        const distance = point.distanceTo(currentRunnerPoint)
        distancesPointMarker.push(distance)
    }

    const smallestDistance = Math.min(...distancesPointMarker)
    const indexOfSmallestDistance = distancesPointMarker.indexOf(smallestDistance)
    const currentRouteOfRunner = raceTracingLatLng.slice(0, indexOfSmallestDistance+1)

    //-- Tracing of the current route of the runner --
    currentRouteOfRunner.push(currentRunnerPoint)
    tracingOfCurrentRouteRunner = L.polyline(currentRouteOfRunner, {color: 'black', weight: currentRaceConfig.strokeWidth}).addTo(map);

}

function removeTracingCurrentRouteOfRunner(){
    //-- Remove the current route of the runner --//
    if(tracingOfCurrentRouteRunner != null){
        map.removeLayer(tracingOfCurrentRouteRunner)
        tracingOfCurrentRouteRunner = null
    }
}

//-- Take an array of races to show in param and hide all races not in the array --
function showRaces(racesToShow){
    racesTracingLayers.forEach( raceLayer => {
        if(racesToShow.includes(raceLayer.idConfig)){
            if(raceLayer.layer._map == null){
                map.addLayer(raceLayer.layerOutline)
                map.addLayer(raceLayer.layer)
            }
        } else {
            if(raceLayer.layer._map != null){
                map.removeLayer(raceLayer.layer)
                map.removeLayer(raceLayer.layerOutline)
            }
        }
    })
}

//-- Put the starting and ending flag on the map to each race --
function placeStartingEndingFlags(){

    if(currentMapMode == "trackingMultipleRunner"){
        raceConfigs.forEach( config => {
            const startingFlagIcon = L.icon({ iconUrl: config.startingRace.flag, iconSize: [37,37], className: 'gr-flags-marker'  })
            startingFlagLayers.push(L.marker([config.startingRace.position.lat, config.startingRace.position.long], { icon: startingFlagIcon }).addTo(map))
        })
    }
    if(currentMapMode == "trackingOneRunner") {
        const config = getConfigByRace(dataOneRunner.info[currentIdDossard].infos.course)
        const startingFlagIcon = L.icon({ iconUrl: config.startingRace.flag, iconSize: [37,37], className: 'gr-flags-marker' })
        startingFlagLayers.push(L.marker([config.startingRace.position.lat, config.startingRace.position.long], { icon: startingFlagIcon }).addTo(map))
    }

    //-- Place the ending flag --
    const endingFlagIcon = L.icon({ iconUrl: raceConfigs[0].endingRace.flag, iconSize: [37,37], className: 'gr-flags-marker' })
    L.marker([raceConfigs[0].endingRace.position.lat, raceConfigs[0].endingRace.position.long], { icon: endingFlagIcon }).addTo(map)
}

//-- Updating markersCluster of runners --
function refreshMakersOfRunners(){
  //console.log('refreshMakersOfRunners')
    let markerIconTemplate='<svg width="40" height="60" viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.47717 3.65257C16.9092 -0.417906 27.3704 -0.0123606 34.3595 6.32616C45.8427 17.9218 29.5498 47.3463 21.4785 57.8454C21.1177 58.3111 20.5616 58.5814 19.9604 58.5814H19.9303C19.269 58.5814 18.6527 58.236 18.292 57.6802C11.6035 46.8356 -7.66546 17.396 5.6214 5.50005" fill="{mapIconColor}"/><path d="M8.47717 3.65257C16.9092 -0.417906 27.3704 -0.0123606 34.3595 6.32616C45.8427 17.9218 29.5498 47.3463 21.4785 57.8454C21.1177 58.3111 20.5616 58.5814 19.9604 58.5814H19.9303C19.269 58.5814 18.6527 58.236 18.292 57.6802C11.6035 46.8356 -7.66546 17.396 5.6214 5.50005L7 4.5L8.47717 3.65257Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/><path d="M27.2359 18.523C27.2359 22.6536 23.8841 26.0031 19.7508 26.0031C15.6174 26.0031 12.2656 22.6536 12.2656 18.523C12.2656 14.3925 15.6174 11.043 19.7508 11.043C23.8841 11.043 27.2359 14.3925 27.2359 18.523Z" fill="white"/></svg>';

    //-- Remove markersCluster before update --
    if(markersCluster.parentGroup != null) markersCluster.parentGroup.removeFrom(map);

    //-- Create a group of runners position markers --
    markersCluster.parentGroup = L.markerClusterGroup()

    //-- Create sub groups of markers and set her parent --
    for (const key in markersCluster.subGroups) {
        markersCluster.subGroups[key] = L.featureGroup.subGroup(markersCluster.parentGroup).addTo(map);
    }

    const data = (currentMapMode == "trackingMultipleRunner" ? Object.values(dataMultipleRunner.info) : Object.values(dataOneRunner.info))
  //console.log('runners:',data)
    for(var z=0;z<data.length;z++){
        //console.log('z:',z)
      let runner=data[z];
        //console.log('runner:',runner)
      //-- une entree sans position (null) ne doit pas interrompre le trace de tous les marqueurs --
      if(runner.dernierePosition && 'lat' in runner.dernierePosition && 'long' in runner.dernierePosition){

      const raceConfig = getConfigByRace(runner.infos.course)
      let iconSettings = {
          mapIconColor: raceConfig.color
      }
      //console.log('iconSettings:',iconSettings)
      //-- Create a icon marker depending of the race --
      const markerIcon = L.divIcon({
          html:L.Util.template(markerIconTemplate, iconSettings),
          iconSize: [25, 40],
          iconAnchor: [15, 50],
          popupAnchor: [120, 27],
          // coureur sans balise : marqueur attenue (position = dernier point de passage)
          className: 'gr-runners-marker' + (runner.infos.sansBalise ? ' gr-runners-marker-sans-balise' : ''),
      })
      //console.log('runner.dernierePosition:',runner.dernierePosition)

      const marker = L.marker( [runner.dernierePosition.lat, runner.dernierePosition.long], { icon: markerIcon} )
      marker.on('click', (event) => handlePopupMarker(event, raceConfig.class, raceConfig.classText, raceConfig.classbg, raceConfig.markerPopupTitle, runner.id_dossard, runner.infos.prenom, runner.infos.nom, runner.infos.clt,runner.infos.etat, runner.infos.sansBalise, runner.infos.nomEtape))

      if(markersCluster.subGroups[runner.infos.course]) markersCluster.subGroups[runner.infos.course].addLayer(marker)
      }
    }
    /*data.forEach( runner => {

        const raceConfig = getConfigByRace(runner.infos.course)
        let iconSettings = {
            mapIconColor: raceConfig.color
        }
        //-- Create a icon marker depending of the race --
        const markerIcon = L.divIcon({
            html:L.Util.template(markerIconTemplate, iconSettings),
            iconSize: [25, 40],
            iconAnchor: [15, 50],
            popupAnchor: [120, 27],
            className: 'gr-runners-marker',
        })


        const marker = L.marker( [runner.dernierePosition.lat, runner.dernierePosition.long], { icon: markerIcon} )
        marker.on('click', (event) => handlePopupMarker(event, raceConfig.class, raceConfig.classText, raceConfig.classbg, raceConfig.markerPopupTitle, runner.id_dossard, runner.infos.prenom, runner.infos.nom, runner.infos.clt,runner.infos.etat))

        if(markersCluster.subGroups[runner.infos.course]) markersCluster.subGroups[runner.infos.course].addLayer(marker)
    })*/

    const sessionData = JSON.parse(sessionStorage.getItem('grData'))

    if(Object.prototype.hasOwnProperty.call(sessionData,'raceFiltering') && currentMapMode == "trackingMultipleRunner"){
        for (const filter in sessionData.raceFiltering) {
            if(!sessionData.raceFiltering[filter] && markersCluster.subGroups[filter]) map.removeLayer(markersCluster.subGroups[filter])
        }
    }

    //-- Vue generale seulement : le libelle de la carte redevient celui du temps reel
    //-- (en vue d'un coureur, c'est le remplissage de la fiche qui le fixe) --
    const labelCarteGenerale = document.querySelector('.gr-fiche-coureur-info-label')
    if(labelCarteGenerale && currentMapMode == "trackingMultipleRunner") labelCarteGenerale.textContent = 'POSITION EN TEMPS RÉEL'

    //-- Add the parent group to the map --
    markersCluster.parentGroup.addTo(map)
}



function handlePopupMarker(event, className, classText, classbg, markerPopupTitle, id_dossard, prenom, nom, clt,etat, sansBalise, nomEtape){
    let br = document.createElement("br");
    let popupmarker = document.createElement("p");
    popupmarker.classList.add("gr-suivi-coureur-marker-popup-content");
    popupmarker.classList.add(className);
    let span1=document.createElement("span");
    span1.classList.add(classText);
    let textNode1=document.createTextNode(markerPopupTitle);
    span1.appendChild(textNode1);
    popupmarker.appendChild(span1);
    popupmarker.appendChild(br.cloneNode(false));
    let textNode=document.createTextNode("N° dossard : "+id_dossard);
    popupmarker.appendChild(textNode);
    popupmarker.appendChild(br.cloneNode(false));

    if(prenom!=''){
      let span2=document.createElement("span");
      span2.classList.add("gr-suivi-coureur-marker-popup-runner-firstName");
      let textNode2=document.createTextNode("Prénom : "+capitaliser(prenom));
      span2.appendChild(textNode2);
      popupmarker.appendChild(span2);
      popupmarker.appendChild(br.cloneNode(false));
    }

    let textNode3=document.createTextNode(" ");
    popupmarker.appendChild(textNode3);
    let span4=document.createElement("span");
    //span4.classList.add("gr-suivi-coureur-marker-popup-runner-name");
    let textNode4=document.createTextNode("Nom : ");
    span4.appendChild(textNode4);
    popupmarker.appendChild(span4);
    let span4b=document.createElement("span");
    span4b.classList.add("uk-text-uppercase");
    let textNode4b=document.createTextNode(nom);
    span4b.appendChild(textNode4b);
    popupmarker.appendChild(span4b);
    popupmarker.appendChild(br.cloneNode(false));
    let span4c=document.createElement("span");
    let textNode4c=document.createTextNode("Etat : ");
    span4c.appendChild(textNode4c);
    popupmarker.appendChild(span4c);
    let textNode4d=document.createTextNode(etat);
    popupmarker.appendChild(textNode4d);
    popupmarker.appendChild(br.cloneNode(false));

    let span5=document.createElement("span");
    //span5.classList.add("gr-suivi-coureur-marker-popup-runner-name");
    let textNode5=document.createTextNode("Classement : ");
    span5.appendChild(textNode5);
    popupmarker.appendChild(span5);

    let textNode6=document.createTextNode(( clt > 0 ? clt : '-' ));
    popupmarker.appendChild(textNode6);

    let span7=document.createElement("sup");
    let textNode7=document.createTextNode(( clt == 1 ? 'er' : 'ème' ));
    span7.appendChild(textNode7);
    popupmarker.appendChild(span7);

    //-- Coureur sans balise GPS : sa position est celle de son dernier point de passage, pas du temps reel --
    if(sansBalise){
      popupmarker.appendChild(br.cloneNode(false));
      let spanSansBalise=document.createElement("span");
      spanSansBalise.classList.add("gr-popup-sans-balise");
      spanSansBalise.appendChild(document.createTextNode("Sans balise GPS : position au dernier point de passage" + (nomEtape ? " (" + nomEtape + ")" : "") + ", pas de temps réel."));
      popupmarker.appendChild(spanSansBalise);
    }

    let span8=document.createElement("span");
    span8.classList.add("gr-suivi-coureur-marker-popup-arrow");
    span8.classList.add(classbg);
    popupmarker.appendChild(span8);

    event.target.bindPopup(popupmarker,{closeButton: false, minWidth: 170, minHeight: 90})
    event.target.openPopup()
    event.target.on('popupclose', () => event.target.unbindPopup())
}

//-- Return a promise with the JSON of the GPX file --
async function convertGpxToJSON(gpxURL){
    const response = await fetch(gpxURL)
    const gpxDOM = new DOMParser().parseFromString(await response.text(), "text/xml")
    return toGeoJSON.gpx(gpxDOM)
}

//-- Get the configuration of a race thanks to the idConfig --
function getConfigByRace(idConfig){
    let config = null

    raceConfigs.forEach( raceConfig => {
        if(raceConfig.idConfig == idConfig) config = raceConfig
    })

    return config
}

function handleChangeMap(e){
    const currentElement = e.currentTarget
    //-- Get some data --
    currentMapMode = currentElement.getAttribute('data-current-map')
    currentIdDossard = currentElement.hasAttribute('data-id-dossard') ? currentElement.getAttribute('data-id-dossard') : null

    //-- Update session storage --
    setSessionStorage({ currentMapMode: currentMapMode, currentIdDossard: currentIdDossard })

    //-- Change the panel depending of the currentMapMode --
    if(currentMapMode == 'trackingMultipleRunner') {
        clearTimeout(refSetTimeoutOneRunner)
        removeTracingCurrentRouteOfRunner()
        refreshingDataOnTrackingMultipleRunner()
        document.querySelector("li.li-suivre-la-course.li-suivre-la-course-mobile").classList.add('uk-hidden');
        document.querySelector("li.li-filter-la-course").classList.remove('uk-hidden');
    }
    if(currentMapMode == 'trackingOneRunner') {
        clearTimeout(refSetTimeoutMultipleRunner)
        clearTimeout(refSetTimeoutOneRunner)
        refreshingDataOnTrackingOneRunner()
        document.querySelector("li.li-suivre-la-course.li-suivre-la-course-mobile").classList.remove('uk-hidden');
        document.querySelector("li.li-filter-la-course").classList.add('uk-hidden');
    }

    //-- Refresh all layers of the map --
    refreshLayersMap()

    //-- Remove suggestions of the search bar --
    const suggestions = document.querySelectorAll("#gr-2022-header-list-suggestion li")
    suggestions.forEach( suggestion => suggestion.remove())

    //-- Clear the input of the search bar --
    document.querySelector(".gr-suivi-coureur-header form input").value = ""

    //-- Fermeture du panel ranking si ouvert
    const panel = document.querySelector("#gr-suivi-coureur-panel-ranking")
    const openClass = "gr-suivi-coureur-panel-ranking-open"
    const closeClass = "gr-suivi-coureur-panel-ranking-close"

    if(panel.classList.contains(openClass)){
        //-- Close the ranking panel --
        panel.classList.replace(openClass, closeClass)
    }

    adjusingtMessageOverlayMap()

    adjustingAlignementInfoLabel()
    fixProblemMapHeight()
}
function handleClickHome(){
  const panel = document.querySelector("#gr-suivi-coureur-panel-ranking")
  const openClass = "gr-suivi-coureur-panel-ranking-open"
  const closeClass = "gr-suivi-coureur-panel-ranking-close"

  if(panel.classList.contains(openClass)){
      //-- Close the ranking panel --
      panel.classList.replace(openClass, closeClass)
  }
}
//-- Use to open and close the Map (Multiple Runner)--
function handleClickToogleMap(){
    const container = document.querySelector("#gr-suivi-coureur-container")
    const toogle = document.querySelector("#gr-suivi-coureur-text-toggle-map")
    const closeMap = "gr-suivi-coureur-map-close"
    const openMap = "gr-suivi-coureur-map-open"

    if (container.classList.contains(closeMap)){
        container.classList.replace(closeMap, openMap)
        toogle.textContent = "Retour"
    } else{
        container.classList.replace(openMap, closeMap)
        toogle.textContent = "Voir la carte"
    }

    adjusingtMessageOverlayMap()
    adjustingAlignementInfoLabel()
    adjustingMapCenter()
}

//-- Use to open and close the Map (One Runner)  --
function handleClickToogleMapRunnerDesktop(e, device){
    //-- Toogle map suivi d'un coureur --
    let toggleText
    const panel = document.querySelector("#gr-fiche-coureur-panel-container")
    if(device === "desktop")  toggleText = document.querySelector("#gr-fiche-coureur-toggle-panel p")

    if(panel.classList.contains('gr-fiche-coureur-close-panel')){
        panel.classList.replace("gr-fiche-coureur-close-panel", "gr-fiche-coureur-open-panel")

        document.querySelector("#gr2022-infos-coureur-button-mobile span.openInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.openInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.closeInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.closeInfos").classList.remove('uk-hidden')
        if(device === "desktop") toggleText.textContent = "fermer panel"
    } else{
        panel.classList.replace("gr-fiche-coureur-open-panel", "gr-fiche-coureur-close-panel")
        document.querySelector("#gr2022-infos-coureur-button-mobile span.openInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.openInfos").classList.remove('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile span.closeInfos").classList.add('uk-hidden')
        document.querySelector("#gr2022-infos-coureur-button-mobile svg.closeInfos").classList.add('uk-hidden')
        if(device === "desktop") toggleText.textContent = "ouvrir panel"
    }

    adjusingtMessageOverlayMap()

    adjustingAlignementInfoLabel()

    adjustingMapCenter()
}

//search bar
var state=null



//-- Initialization --
function initSearchBar(){
    initEventsListenersSearchBar()
}
function submitFormSearch(e){
  e.preventDefault()
  e.stopPropagation()
  state.submitter=true
  updateSuggestionsData()
}
//-- Initialize events listeners --
function initEventsListenersSearchBar(){
    //-- Event when value of the input change --
    state.searchFormLive.addEventListener('submit',(e)=>submitFormSearch(e));
    state.inputSearchBar.addEventListener('keyup', () => updateSuggestionsData() )
    state.inputSearchBar.addEventListener('click', (e) => {
        e.stopPropagation()
        updateSuggestionsData()
    })


    //-- Delete suggestion li when user click outside the input --
    window.addEventListener('click', () => {
        const suggestionsLi = document.querySelector("#gr-2022-header-list-suggestion ul").children
        if(suggestionsLi.length != 0) Array.from(suggestionsLi).forEach( li => li.remove() )
    })

}

//-- Update the suggestions data --
function updateSuggestionsData(){
    let suggestions = []
    let errorMessage = null

    //-- Mots saisis, normalises ; on ignore les separateurs --
    const saisie = state.inputSearchBar.value.trim()
    const motsSaisis = normaliser(saisie).split(/[\s'-]+/).filter( function(m){ return m != '' } )

    if(motsSaisis.length == 0) {
        const suggestionsLi = document.querySelector("#gr-2022-header-list-suggestion ul").children
        if(suggestionsLi.length != 0) Array.from(suggestionsLi).forEach( li => li.remove())

        return
    }

    //-- 1) Recherche par numero de dossard (correspondance exacte) --
    suggestions = Object.values(dataMultipleRunner.info).filter( function(runner){
        return saisie.toLowerCase() == runner.id_dossard.toString().toLowerCase()
    }).slice(0, state.maxSuggestions)

    //-- 2) Sinon recherche par nom / prenom.
    //--    CHAQUE mot saisi doit correspondre au debut d'un des mots du coureur : taper
    //--    le nom complet fonctionne, et un nom a particule se trouve par n'importe quel
    //--    de ses morceaux. L'ancienne version ecrasait le test a chaque mot, seul le
    //--    DERNIER comptait, ce qui rendait "JEAN-BENOIT LE HOUE" introuvable. --
    if (suggestions.length == 0) {
        suggestions = Object.values(dataMultipleRunner.info).filter( function(runner){
            const mots = motsCherchables(runner.infos.nom, runner.infos.prenom)
            return motsSaisis.every( function(motSaisi){
                return mots.some( function(mot){ return mot.startsWith(motSaisi) })
            })
        }).slice(0, state.maxSuggestions + 1)
    }

    //-- Init error message --
    if (suggestions.length == 0 ){
        errorMessage = "Aucun résultat trouvé parmi les coureurs affichés sur la carte. "
    } else if (suggestions.length > state.maxSuggestions){
        errorMessage = "Trop de résultats."
        suggestions = suggestions.slice(0, state.maxSuggestions)
    }

    //-- Update the suggestions data and retrieve limit the content --
    state.suggestionsData = suggestions

    //-- Display suggestions --
    displaySuggestions(errorMessage)
}

//-- Lien de repli vers LiveTrail (site v3, edition 2026) : un numero de dossard ouvre la fiche du coureur,
//-- tout autre texte ouvre la recherche. Un dossard de relayeur Zembrocal (5 chiffres commencant par 8)
//-- est ramene a son equipe, la seule connue de LiveTrail. --
function urlLiveTrail(saisie){
    const base = "https://grandraid-reunion.v3.livetrail.net/fr/2026/"
    let valeur = (saisie || "").trim()
    if(/^\d+$/.test(valeur)){
        if(valeur.length === 5 && valeur[0] === "8"){ valeur = valeur.slice(0, 4) }
        return base + "runners/" + valeur
    }
    return base + "search?query=" + encodeURIComponent(valeur)
}

//-- Display the list of suggestions --
function displaySuggestions(errorMessage){
    const suggestionsContainer = document.querySelector("#gr-2022-header-list-suggestion ul")

    //-- Remove the existing suggestions before display news --
    document.querySelectorAll("#gr-2022-header-list-suggestion ul li").forEach((item) => {
        item.remove()
    })

    if(errorMessage) {
        const lialt = document.createElement("li");
        lialt.classList.add('gr-search-bar-error-message')
        //lialt.textContent = errorMessage
        const newalt = document.createElement("a")
        const txtlink = document.createTextNode(errorMessage+" Cliquez ici pour rechercher sur Live Trail.")
        newalt.setAttribute("href", urlLiveTrail(state.inputSearchBar.value));
        newalt.setAttribute("target", "_blank")
        newalt.appendChild(txtlink)
        newalt.classList.add('link-to-livetrail')
        lialt.appendChild(newalt)
        suggestionsContainer.appendChild(lialt)

        //return // Exit the function to not display suggestions
    }
    else{
      //-- Create the suggestions elements --
      for (const suggestion of state.suggestionsData) {
          const newli = document.createElement("li");
          const dash = document.createTextNode("- ")
          const newa = document.createElement("a")
          newa.setAttribute("data-current-map", "trackingOneRunner")
          newa.setAttribute("data-id-dossard", suggestion.id_dossard)
          newa.addEventListener('click',handleChangeMap);

          const numElement = document.createElement('strong')
          numElement.textContent = "N° "

          const prenom = highlightSuggestion(capitaliser(suggestion.infos.prenom))
          const nom = highlightSuggestion(suggestion.infos.nom)
          nom.classList.add('uk-text-uppercase')
          newa.append(numElement, highlightSuggestion(suggestion.id_dossard), dash, prenom, nom)

          newli.appendChild(newa)
          suggestionsContainer.appendChild(newli)
      }
    }
    if(state.submitter && state.suggestionsData.length==1){
      const toclick = suggestionsContainer.querySelector('a')
      simulateClick(toclick)
    }
    state.submitter=false;
}
function simulateClick(elem){
  var evt = new MouseEvent('click',{
    bubbles:true,
    cancelable:true,
    view:window
  });
  elem.dispatchEvent(evt);
}
//-- Highlight part of the suggestion --
function highlightSuggestion(texteAffiche){
    const texte = (texteAffiche === null || texteAffiche === undefined ? '' : texteAffiche).toString()
    let highlightingText = document.createElement('span')
    highlightingText.textContent = texte + " "

    //-- On compare en normalise (sans accent ni apostrophe typographique) mais on affiche
    //-- le texte tel quel, pour ne pas ecraser la casse choisie par l'appelant. --
    const reference = normaliser(texte)
    const motsSaisis = normaliser(state.inputSearchBar.value).split(/[\s'-]+/).filter( function(m){ return m != '' } )

    motsSaisis.forEach( function(motSaisi){
        if( reference.startsWith(motSaisi) ){
            const span = document.createElement('span')
            const strong = document.createElement('strong')
            strong.textContent = texte.slice(0, motSaisi.length)
            span.appendChild(strong)
            span.appendChild(document.createTextNode(texte.slice(motSaisi.length) + " "))
            highlightingText = span
        }
    })

    return highlightingText
}

//Classement
function initClassement() {
    initEventsListenersClassement()
}

function initEventsListenersClassement(){
    //-- Ranking button on the header --
    document.querySelector("#gr-suivi-coureur-ranking-button").addEventListener('click', handlePanel)
    //-- Ranking CTA --
    document.querySelector("#gr-suivi-coureur-ranking-cta").addEventListener('click', handlePanel)
    //-- Toogle panel on mobile --
    document.querySelector("#gr-suivi-coureur-panel-ranking .gr-fiche-coureur-toggle-panel-mobile").addEventListener('click', handlePanel)

    //-- Button "classement" footer mobile --
    document.querySelector("#gr2022-classement-button-mobile").addEventListener('click', handlePanel)
    //-- Close Button Panel Ranking --
    document.querySelector(".gr-suivi-coureur-panel-ranking-cross-icon").addEventListener('click', handlePanel)


    //-- See ranking button on mobile --
    const buttons =  document.querySelectorAll("#gr-suivi-coureur-panel-ranking .gr-suivi-coureur-see-ranking-button")
    buttons.forEach( button => {
        button.addEventListener('click', (e) => {
            const container = e.currentTarget.closest(".gr-suivi-coureur-table-container")
            const openClass = "gr-suivi-coureur-table-container-open"
            const closeClass = "gr-suivi-coureur-table-container-close"

            if(container.classList.contains(closeClass)){
                container.classList.replace(closeClass, openClass)
                e.currentTarget.textContent = "Masquer le classement"
            } else{
                container.classList.replace(openClass, closeClass)
                e.currentTarget.textContent = "Voir le classement"
            }
        })
    })
}

function handlePanel(){
    const panel = document.querySelector("#gr-suivi-coureur-panel-ranking")
    const openClass = "gr-suivi-coureur-panel-ranking-open"
    const closeClass = "gr-suivi-coureur-panel-ranking-close"

    if(panel.classList.contains(closeClass)){
        initRankingTable()
        //-- Open the ranking panel --
        panel.classList.replace(closeClass, openClass)
        document.querySelector("span.openClassement").classList.add('uk-hidden')
        document.querySelector("svg.openClassement").classList.add('uk-hidden')
        document.querySelector("span.closeClassement").classList.remove('uk-hidden')
        document.querySelector("svg.closeClassement").classList.remove('uk-hidden')
    } else {
        //-- Close the ranking panel --
        panel.classList.replace(openClass, closeClass)
        document.querySelector("span.openClassement").classList.remove('uk-hidden')
        document.querySelector("svg.openClassement").classList.remove('uk-hidden')
        document.querySelector("span.closeClassement").classList.add('uk-hidden')
        document.querySelector("svg.closeClassement").classList.add('uk-hidden')
    }
}

function initRankingTable(){
    const tableContents = document.querySelectorAll("#gr-suivi-coureur-panel-ranking table tbody")

    //-- Remove existing elements from each table before refresh table data --
    tableContents.forEach( tbody => {
        Array.from(tbody.children).forEach( child => child.remove() )
    })

    fetch(urlPosition('classement.json'), {
        method: 'GET'
    })
    .then( response => response.json())
    .then( data => {
        raceConfigs.forEach( race => {
            //-- Le Zembrocal est un relais : une balise par equipe, pas de categorie
            //-- femme/homme. Une seule table, et on n'y filtre pas sur le sexe. --
            if(race.idConfig == "Zembrocal Trail"){
                refreshTableData(data, race.idConfig, null)
            } else {
                refreshTableData(data, race.idConfig, 'f')
                refreshTableData(data, race.idConfig, 'm')
            }
        })
    })
}

function refreshTableData(data, course, sexe){
    //-- sexe null = pas de distinction femme/homme (Zembrocal) : id de table sans suffixe --
    const tableId = course.replaceAll(' ', '-').toLowerCase() + (sexe ? '-'+sexe.toLowerCase() : '')
    const tbody = document.querySelector('#gr-ranking-table-'+tableId+' tbody')
    let nbRow = 0

    //-- la table peut avoir ete retiree du DOM : on ne va pas plus loin --
    if(!tbody) return

    if(data.status == 'succes'){
            for (const runner of data.info) {
                if(runner.course == course && (!sexe || (runner.sexe || '').toLowerCase() == sexe.toLowerCase())){
                    //----- CREATE ROW -----
                    //-- tr --
                    const tr = document.createElement('tr')
                    //-- td 1 --
                    const td1 = document.createElement('td')
                    td1.classList.add('uk-text-center', 'uk-text-capitalize')
                    const td1text = document.createTextNode(runner.clt)
                    td1.appendChild(td1text)
                    //-- td 2 --
                    const td2 = document.createElement('td')
                    td2.classList.add('uk-text-center', 'uk-text-capitalize')
                    const td2text = document.createTextNode(runner.dossard)
                    td2.appendChild(td2text)
                    //-- td 3 --
                    const td3 = document.createElement('td')
                    td3.classList.add('uk-text-center')
                    const span1 = document.createElement('span')
                    span1.classList.add('uk-text-capitalize')
                    span1.appendChild(document.createTextNode(runner.prenom))
                    const span2 = document.createElement('span')
                    span2.classList.add('uk-text-uppercase')
                    span2.appendChild(document.createTextNode(runner.nom))
                    td3.append(span1, document.createTextNode(' ') ,span2)
                    //-- td 4 --
                    const td4 = document.createElement('td')
                    td4.classList.add('uk-text-center', 'uk-text-capitalize')
                    const td4text = document.createTextNode(runner.temps)
                    td4.appendChild(td4text)

                    //----- APPENDS -----
                    //-- Append tr to tbody --
                    tbody.appendChild(tr)
                    //-- Append td to tr --
                    tr.append(td1, td2, td3, td4)

                    //----- INCREMENT NUMBER OF ROWS -----
                    nbRow++

                    //----- BREAK THE LOOPS DENPENDING NUMBER OF ROWS AUTHORIZED -----
                    if(nbRow == maxRowsRankingTable) break
                }
            }

            //------ DISPLAY A MESSAGE IF THERE IS NO DATA -----
            if(nbRow == 0){
                //-- tr --
                const tr = document.createElement('tr')
                //-- td --
                const td = document.createElement('td')
                td.setAttribute('colspan', '4')
                td.classList.add('uk-text-center')
                const tdText = document.createTextNode('Aucun résultat.')
                //-- appends --
                tbody.appendChild(tr)
                tr.appendChild(td)
                td.appendChild(tdText)
            }
        }

}
function fixProblemMapHeight(){
    const container = document.querySelector(".gr-suivi-coureur-pleine-hauteur")

    const fixHeight = () => {
      (currentMapMode == 'trackingOneRunner') ? container.classList.add('fix-height-map-one-runner') : container.classList.remove('fix-height-map-one-runner')
    }

    fixHeight()

    window.addEventListener('resize', fixHeight)
}



window.addEventListener('load',()=>{
    //console.log('Load')
    state={
        searchFormLive: document.querySelector("#searchFormLive"),
        inputSearchBar: document.querySelector(".gr-nav-container input"),
        suggestionsData: null,
        maxSuggestions: 5,
        runners: null,
        submitter:false
    }

    init()
    initSearchBar()
    initClassement()
});
